import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import CopyPublicationUrl from '../../../../../components/Editor/EditPanel/SettingsPanel/CopyPublicationUrl';
import { getClientAndResourceIds } from '../../../utils/helpers';
import { Api } from '../../../../../typings/api';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			settings: {
				projectUrl,
				serverErrors,
			},
		},
	} = state;
	const { originalGId: publicationId } = getClientAndResourceIds();

	return {
		publicationId,
		projectUrl,
		isDisabled: !!serverErrors[Api.PublicationSettingName.customUrl],
	};
};

export default connect(mapStateToProps)(CopyPublicationUrl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SettingsPanel/CopyPublicationUrl/index.tsx